import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import relationService from "~/modules/relation/service/relation.service";

export function useUpdateReferentUser(params: GenericParameters) {
  let service =
    relationService.updateBusinessUnitReferentUser.bind(relationService);

  if (params.organizationCode) {
    service =
      relationService.updateOrganizationReferentUser.bind(relationService);
  }

  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);

  async function updateReferentUser(referentUserLogin: string) {
    isLoading.value = true;
    error.value = undefined;

    const response = await service({ ...params, referentUserLogin });

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    updateReferentUser,
    isLoading,
    error,
  };
}
